import { z } from 'zod';

/**
 * Schema do form de Falta.
 *
 * Regras (card [NRCe0RwN] T-21):
 * - `dataFalta` ISO `YYYY-MM-DD` (DatePicker).
 * - `justificada` boolean.
 * - `motivo` livre (sem regra opcional do PRD — confirmado com Claudio 2026-06-08).
 *
 * PK é `dataFalta`; em Edit fica disabled.
 */
export const employeeFaltaInputSchema = z.object({
  dataFalta: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (use AAAA-MM-DD)'),
  justificada: z.boolean(),
  motivo: z.string().max(500, 'Máximo 500 caracteres'),
});

export type EmployeeFaltaFormValues = z.infer<typeof employeeFaltaInputSchema>;
